module.exports = __webpack_public_path__ + "img/full_glass_icon.e2f2b6a1.png";